import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { TextField } from "../fields/TextField";

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  helperText?: string;
  labelIcon?: React.ReactNode;
  name: string;
  floatingElement?: React.ReactNode;
}

export const TextInput = ({
  name,
  onChange,
  floatingElement,
  ...rest
}: Props) => {
  const { control, register, getFieldState, formState } = useFormContext();

  const { ref, onChange: hookOnChange, ...hookFormProps } = register(name);

  const customOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    hookOnChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  const value =
    useWatch({
      name,
      control,
    }) || "";

  return (
    <TextField
      errorMessage={getFieldState(name, formState).error?.message}
      value={value}
      innerRef={ref}
      floatingElement={floatingElement}
      onChange={customOnChange}
      {...rest}
      {...hookFormProps}
    />
  );
};
